import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MvnoMetricsModel } from 'src/app/models/mvno-metrics.model';
import { Organization } from 'src/app/models/organization.model';


interface MvnoSummary {
  clientName: string;
  organizationId: string;
  nbLines: number;
  status: string;
}

@Component({
  selector: 'app-service-mvno-dialog',
  standalone: true,
  templateUrl: './service-mvno-dialog.component.html',
  styleUrl: './service-mvno-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, MatTableModule, MatButtonModule, MatIconModule],
})
export class ServiceMvnoDialogComponent {
  displayedColumns = ['clientName', 'metrics', 'status', 'actions'];

  summary: MvnoSummary[] = [];

  constructor(
    public dialogRef: MatDialogRef<ServiceMvnoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { mvno: MvnoMetricsModel; organization: Organization }
  ) {
    this.buildSummary(data);
  }

  private buildSummary(data: {
    mvno: MvnoMetricsModel;
    organization: Organization;
  }): void {
    this.summary = [
      {
        clientName: data.organization.display,
        organizationId: data.organization.id,
        nbLines: data.mvno.nbLines,
        status: data.mvno.nbLines > 0 ? 'Actif' : 'Inactif',
      },
    ];
  }

  goToNexusMvno(orgId: string): void {
    const url = `https://nexus-mvno.tel4btest.com/`;
    window.open(url, '_blank');
  }

  toggleAccess(orgId: string): void {
    console.log(`TODO: activer/désactiver MVNO pour ${orgId}`);
  }

  close(): void {
    this.dialogRef.close();
  }
}
